/**
 * TOP 7 mini add-to-cart: any <form data-t7-mini-atc> adds its item through the
 * native Eurus cart contract (xCartHelper.withCartLock -> cart/add.js ->
 * reRenderSections -> mini cart). Without Alpine the form simply submits to
 * /cart/add, so the button always works.
 */
(() => {
  if (window.__t7MiniAtc) return;
  window.__t7MiniAtc = true;

  document.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest('form[data-t7-mini-atc]');
    if (!form || !window.Alpine) return;
    const helper = Alpine.store('xCartHelper');
    const miniCart = Alpine.store('xMiniCart');
    if (!helper || !miniCart) return;
    e.preventDefault();

    const btn = form.querySelector('button');
    const items = [{ id: form.elements.id.value, quantity: parseInt(form.elements.quantity.value, 10) || 1 }];
    if (btn) btn.setAttribute('aria-busy', 'true');

    const run = (standardEvent) =>
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: helper.getSectionsToRender().map((s) => s.id) })
      })
        .then((r) => helper.cartJson(r))
        .then((response) => {
          if (response.status == '422') {
            if (standardEvent) return helper.settleWithCart(standardEvent, helper.userErrorsFrom(response));
            return;
          }
          if (response.sections) helper.reRenderSections(response.sections);
          document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: response.items || response } }));
          miniCart.openCart();
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          if (standardEvent) return helper.settleWithCart(standardEvent);
        })
        .catch((err) => {
          if (standardEvent) standardEvent.fail(err);
          console.error('TOP7 mini add error:', err);
        })
        .finally(() => { if (btn) btn.removeAttribute('aria-busy'); });

    if (helper.withCartLock) {
      helper.withCartLock((ev) => run(ev), {
        type: 'shopify:cart:lines-update', action: 'add', context: 'product',
        lines: helper.addLines ? helper.addLines(items) : undefined
      });
    } else {
      run(null);
    }
  });
})();
